<template>
  <div
    ref="panel"
    :class="[{dark: isDark}, 'subscribe-panel-mini']"
  >
    <div class="artwork-meta">
      <Artwork />
      <MetaInfo />

      <a
        :href="episodeUrl"
        class="share"
        target="simplecast-share"
      >
        <icon-share />
      </a>
    </div>
  </div>
</template>

<script>
import Artwork from './Artwork'
import IconShare from '../assets/svg/share-mini.svg'
import MetaInfo from './MetaInfo'
import Store from '../store'

export default {
  components: {
    Artwork,
    IconShare,
    MetaInfo
  },
  data () {
    return { store: Store }
  },
  computed: {
    episodeUrl () { return this.store.state.episode.episode_url },
    isDark () { return this.store.state.isDark }
  }
}
</script>

<style lang="scss" scoped>
@import 'node_modules/simplecast-styles/src/assets/styles/_core/colors.scss';

.subscribe-panel-mini {
  box-sizing: border-box;
  left: 0;
  padding: 8px 56px 0 50px;
  position: absolute;
  top: 0;
  width: 100%;

  .artwork {
    height: 36px;
    margin-right: 8px;
    width: 36px;
  }
  .artwork-meta {
    display: flex;
  }
  .meta-info {
    flex: 1;

    /deep/ h1 {
      line-height: 31px;
    }
    /deep/ h2 {
      display: none;
    }
  }
  .share {
    align-items: center;
    background: none;
    border-radius: 4px;
    border: solid 1px $black-800;
    color: $black-800;
    display: flex;
    height: 34px;
    justify-content: center;
    position: relative;
    width: 34px;
    z-index: 10;
  }

  &.dark {
    .share {
      border: solid 1px $white-000;
      color: $white-000;

      svg {
        fill: $white-000;
      }
    }
  }
}
</style>
